import React, { Component } from "react"
import 'bootstrap/dist/css/bootstrap.css';
import { setFullName, setMobile, setNin, setServiceType, setToken } from "../core/actions/common";
import { connect } from "react-redux";
import { State } from '../core/reducers';
import appconfig from "./../appconfig.json";
import axios from 'axios';
import setLanguage, { translations } from 'translation';
import {notSentOtpAlert} from "../Utils/helpers";
export interface CommonProps {
    serviceType: string;
    fullName: string;
    nin: string;
    mobile: string;
    token: string;
    setServiceType(serviceType: string): void;
    setFullName(fullName: string): void;
    setNin(nin: string): void;
    setMobile(mobile: string): void;
    setToken(token: string): void;
}

class InputForm extends Component {
    constructor(public props: CommonProps) {
      
        super(props);
        
    }

    
    state = {
        nin: '',
        mobile: '',
        isSignLanguage: 'No'
    };
    absherIntegrationStatus: boolean = true;
    componentDidMount(): void {
        this.checkAbsherIntegration();
        let language = localStorage.getItem("lang");
       // console.log("kiro",language)
        setLanguage(language);
    }
    checkAbsherIntegration = () => {
       let url = appconfig.azure_reports_url + "/report/absherstatus";
        fetch(url).then(response => {
            return response.json();
        }).then(json => {
            console.log("absher statusresponse = " + json.status)
            if (json.status == "enabled") {
                this.absherIntegrationStatus = true;
            } else {
                this.absherIntegrationStatus = false;
            }
        }).catch(error => {
            alert("Fetch absher status error > " + error)
        }) 

    }
    openWelcomeScreen = () => {
        const languageSelector = document.getElementById("languageSelector") as HTMLInputElement;
        let language = languageSelector.value;
        let serviceType =  document.getElementById('entity') as HTMLInputElement;
        let nin = document.getElementById('nin') as HTMLInputElement;
        let name = document.getElementById('fullname') as HTMLInputElement;
        let mobile = document.getElementById('mobile') as HTMLInputElement;
        let serviceTypeValidationMsg = document.getElementById('entityRequiredMsg') as HTMLElement;
        let ninRequiredMsg = document.getElementById('ninRequiredMsg') as HTMLElement;
        let nameRequiredMsg = document.getElementById('nameRequiredMsg') as HTMLElement;
        let mobileRequiredMsg = document.getElementById('mobileRequiredMsg') as HTMLElement;
        let securityVonfirmRequiredMsg = document.getElementById('securityVonfirmRequiredMsg') as HTMLElement;
        var numbersExp = /^[0-9]+$/;
        let validInputs = true;
        let nametest =/^[\u0621-\u064A [a-zA-Z]*$/;
         //serviceType.value == "gosi-public-main" ||
         //uncomment
         if (serviceType.value == null || serviceType.value == "0") {
            let language = localStorage.getItem("lang");
            if(language === "ar"){
                serviceTypeValidationMsg.innerText = "الرجاء اختيار نوع الخدمة";
            }
            else{
                serviceTypeValidationMsg.innerText = "Please choose the type service";
            }
            //serviceTypeValidationMsg.innerHTML = "الرجاء اختيار نوع الخدمة";
            serviceTypeValidationMsg.style.display = '';
            validInputs = false;
        } else {
            serviceTypeValidationMsg.style.display = 'none';
        }
       
        

        if (nin.value == "") {
            ninRequiredMsg.style.display = '';
            validInputs = false;
        } else {
            ninRequiredMsg.style.display = 'none';
        }

        if (nin.value != "") {
            if (!nin.value.match(numbersExp) || nin.value.length != 10 || !(nin.value.startsWith("1") || nin.value.startsWith("2"))) {
                ninRequiredMsg.innerHTML = "رقم الهوية غير صحيح";
                ninRequiredMsg.style.display = '';
                validInputs = false;
            } else {
                ninRequiredMsg.style.display = 'none';
            }
        }

        if (name.value == "") {
            nameRequiredMsg.style.display = '';
            validInputs = false;
            if(language === "ar"){

                nameRequiredMsg.innerText ="هذا الحقل مطلوب";
            }else{
                nameRequiredMsg.innerText ="Required Field";

            }
        }else if (nametest.test(name.value)) {
            nameRequiredMsg.style.display = 'none';
        } else {
            nameRequiredMsg.style.display = '';
            if(language === "ar"){
                nameRequiredMsg.innerText = "فضلًا أدخل اسمًا صحيحًا";
            }else{
                nameRequiredMsg.innerText = "Please enter a valid name";

            }
            validInputs = false;
        } 

        if (mobile.value == "") {
            mobileRequiredMsg.style.display = '';
            mobile.focus();
            validInputs = false;
        } else {
            mobileRequiredMsg.style.display = 'none';
        }

        if (mobile.value != "") {
            if (!mobile.value.match(numbersExp) || mobile.value.length != 10) {
                //mobileRequiredMsg.innerHTML = "يجب ان يكون رقم الجوال مكون من ١٠ ارقام";
                mobileRequiredMsg.innerHTML = translations[language]["validation_invalid_mobile"];
                mobileRequiredMsg.style.display = '';
                mobile.focus();
                validInputs = false;
            } else {
                mobileRequiredMsg.style.display = 'none';
            }
        }
        let securityConfirm = document.getElementById('securityConfirm') as HTMLInputElement;
        let submitbtn = document.getElementById('submitbtn') as HTMLButtonElement;
        if (securityConfirm.checked == false) {
            submitbtn.style.backgroundColor = "#662577";
            securityVonfirmRequiredMsg.style.display = '';
            validInputs = false;
        } else {
            securityVonfirmRequiredMsg.style.display = 'none';
        }

        if (validInputs == false) {
            return false;
        }
        this.props.setFullName(name.value);
        this.props.setNin(nin.value);
        this.props.setMobile(mobile.value);
        this.props.setServiceType(serviceType.value);

        //let isSignLanguage = document.getElementById('isSignLanguage') as HTMLInputElement;
         
        if (this.absherIntegrationStatus) {
            this.sendOtp();
        } else {
            this.props.setToken('');
            //window.location.href = "?isPublic=true&config=true&fullname=" + name.value + "&nin=" + nin.value + "&mobile=" + mobile.value + "&serviceType=" + serviceType.value
            window.location.href = "?isPublic=true&config=true";
        }

        return true;
    }
    sendOtp = () => {
        let nin = document.getElementById('nin') as HTMLInputElement;
        let name = document.getElementById('fullname') as HTMLInputElement;
        let mobile = document.getElementById('mobile') as HTMLInputElement;
        let submitbtn = document.getElementById('submitbtn') as HTMLInputElement;
        let submitButtonSpinner = document.getElementById('submitButtonSpinner') as  HTMLElement ;
        
       
         console.log(submitButtonSpinner);
        //submitButtonSpinner.style.display = 'inline';
        submitbtn.disabled = true;
        
        let otp_url = appconfig.azure_reports_url + "/api/sendcustomerotp";
        const body = {
            "nin": nin.value,
            "mobile": mobile.value,
            "fullname": name.value
        };

        const options = {
            headers: {
                "Content-Type" : "application/json"
            }
          };

        axios.post(otp_url, body , options).then(response => {
            console.log("send otp response = " + response);
            //alert(JSON.stringify(response));
            if (response.data.successMessage) {
               window.location.href = "otp?isPublic=true&config=true";
            } else {
               //submitButtonSpinner.style.display = 'none';
                submitbtn.disabled = false;
                //alert("Failed to send otp");
                //alert('تعذر ارسال رمز التحقق، الرجاء المحاولة في وقت لاحق');
                notSentOtpAlert()
            }
        }).catch(err => {
           // submitButtonSpinner.style.display = 'none';
            submitbtn.disabled = false;
            console.log(err);
            //alert('تعذر ارسال رمز التحقق، الرجاء المحاولة في وقت لاحق');
            notSentOtpAlert()
        });
    }

    checkNinOnlyDigits = (event: any) => {
        let ninRequiredMsg = document.getElementById('ninRequiredMsg') as HTMLElement;

        const languageSelector = document.getElementById("languageSelector") as HTMLInputElement;
        let language = languageSelector.value;
        const re = /^[0-9\b]+$/;
       //const re = /^[\u0660-\u0669\u06F0-\u06F90-9]/g
        if (event.target.value === '' || re.test(event.target.value)) {
            this.setState({ nin: event.target.value })
            ninRequiredMsg.style.display = 'none'
        }else{
            ninRequiredMsg.style.display = '';
            ninRequiredMsg.innerHTML = translations[language]["validation_only_digits"];
        }
    }


    checkMobileOnlyDigits = (event: any) => {
        const languageSelector = document.getElementById("languageSelector") as HTMLInputElement;
        let language = languageSelector.value;

        let mobileRequiredMsg = document.getElementById('mobileRequiredMsg') as HTMLElement;
        const re = /^[\u0660-\u0669\u06F0-\u06F90-9]/g;
        if (event.target.value === '' || re.test(event.target.value)) {
            this.setState({ mobile: event.target.value })
            mobileRequiredMsg.style.display = 'none'
        }else{
            mobileRequiredMsg.style.display = '';
            mobileRequiredMsg.innerHTML = translations[language]["validation_only_digits"];//" غير مسموح باستخدام الحروف";
        }
        
    }
    addNumber =  (event:any)=>{
        if(event.target.value == ""){

            if (!event.target.value.startsWith('05') && event.target.value.length <= 10) {       // Prepend '05' to the value      
                event.target.value = '05' + event.target.value;     
            }     // Update the phone number 
            this.setState({mobile:event.target.value});
        }
    }
    openUrl = (url:string) =>{
        window.open(url , "_blank")    
        }

    render() {
        return (
            <div className="content-container">
                <div className='row'>

                    <div className="col-md-5 Rside">
                        <div className='row'>
                            <div className='t2' data-i18n="vertualVisit_title"> فرعنا الالكتروني عندك </div>
                        </div>
                        <div className='row'>
                            <span className='p1 p2' data-i18n="vertualVisit_description" >تتيح هذه الخدمة امكانية عقد <b>زيارة افتراضية </b>والتواصل مع موظف خدمة العملاء عبر الاتصال المرئى بكل سهولة ويسر</span>
                        </div>
                        <div className="row" style={{ paddingTop: "30px" }}>
                            <div className='descriptionImage'></div>
                            

                        </div>
                        <br /><br />
                        <div className='row'>
                            <div className='t2'><span className='t2' id="serviceTitle"></span></div>
                        </div>
                        <div className='row'>
                            <span className='p1 p2' id="serviceDescription"></span>
                        </div>
                        <br /><br />
                        <div className='row'>
                            <div className='t2'><span className='t2' id="documentTitle"></span></div>
                        </div>
                        <div className='row'>
                            <span className='p1 p2' id="documentDescription"></span>
                        </div>
                    </div>


                    <div className='col-md-7'>
                        <div className='leftSide'  >
                            <div className='row'>
                                
                                <div className='t1' data-i18n="start_from_here">إبدأ من هنا</div>
                            </div>
                            <div className="row" >
                                <span className="mandatoryfield">*</span>
                                &nbsp;&nbsp;
                                <span className='label1' data-i18n="service_type">نوع الخدمة    </span>
                            </div>

                            <div className="row" >
                                <select className='form-control' name="serviceType" id="entity">
                                    <option value="0" data-i18n="select">اختر</option>
                                    <option value="poc2-inquiry" data-i18n="poc3_option1">استفسارات</option>
                                    <option value="poc2-suggestion" data-i18n="poc3_option2">اقتراحات</option>
                                    <option value="poc2-complaint" data-i18n="poc3_option3">شكاوى</option>
                                </select>
                            </div>
                            <div className="row" >
                                <span id="entityRequiredMsg" style={{ color: "red", display: "none", fontSize: "11px" }}> هذا الحقل مطلوب  </span>
                            </div>
                            <br/>
                            <div id="contentDiv" >
                          
                            <div id="visitEMP">
                                    <div className='row'>
                                        <span className="mandatoryfield">*</span>
                                        &nbsp;&nbsp;
                                        <span className='label1' data-i18n="nin_residence">   الهوية الوطنية / الاقامة</span>
                                    </div>

                                    <div className='row'>
                                        <input className='form-control' value={this.state.nin} maxLength={10} type="text" data-i18n="nin_residence_placeholder" onChange={this.checkNinOnlyDigits} placeholder=' الهوية الوطنية / الاقامة' name='nin' id='nin' />
                                    </div>
                                    <div className="row" >
                                        <span id="ninRequiredMsg" data-i18n="required_field" style={{ color: "red", display: "none", fontSize:"11px" }}>هذا الحقل مطلوب</span>
                                    </div>
                                    <br/>

                                    <div className='row'>
                                        <span className="mandatoryfield">*</span>
                                        &nbsp;&nbsp;
                                        <span className='label1' data-i18n="name"> الاسم</span>
                                    </div>

                                    <div className='row'>
                                        <input className='form-control' type="text" data-i18n="name_placeholder" placeholder='الاسم' name='fullname' id='fullname' />
                                    </div>
                                    <div className="row">
                                        <span id="nameRequiredMsg" data-i18n="required_field" style={{ color: "red", display: "none", fontSize:"11px" }}></span>
                                    </div>

                                    <br></br>
                                    <div className='row'>
                                        <span className="mandatoryfield">*</span>
                                        &nbsp;&nbsp;
                                        <span className='label1' data-i18n="mobile">رقم الجوال  </span>
                                    </div>
                                    <div className='row'>
                                    <input className='form-control' maxLength={10} value={this.state.mobile} onFocus={this.addNumber} onChange={this.checkMobileOnlyDigits} type="text" placeholder='05xxxxxxxx' name='mobile' id='mobile' />
                                    </div>
                                    <div className="row" >
                                        <span id="mobileRequiredMsg" data-i18n="required_field" style={{ color: "red", display: "none", fontSize:"11px" }}>هذا الحقل مطلوب</span>
                                    </div>
                                    <br />
                                
                                    <div className='row'>
                                        {/*<span className="mandatoryfield">*</span>*/}
                                        &nbsp;&nbsp;
                                        <span className='label1' data-i18n="email">الإيميل</span>
                                    </div>

                                    <div className='row'>
                                        <input className='form-control'  style={{ fontFamily: "tahoma !important" }} type="email" data-i18n="email_placeholder" placeholder='الإيميل' name='email' id='email' />
                                    </div>
                                    <div className="row">
                                        <span id="emailRequiredMsg" style={{ color: "red", display: "none", fontSize: "11px" }} data-i18n="validation_email">الإيميل غير صحيح</span>
                                    </div>
                                    <br />
                                    <br />
                                    <div className='row'>
                                        <div className="col-md-12" >
                                            <span className="mandatoryfield">*</span>
                                            &nbsp;&nbsp;
                                            <input type="checkbox" name='securityConfirm' id='securityConfirm' value="confirmed" />
                                            <span  data-i18n="confirmation_text"> أتعهد انا مستخدم هذه الخدمة بعدم تسجيل هذه المكالمة وأن احافظ على سرية البيانات الواردة فيها التزاماً بكافة الأحكام والقواعد الواردة في نظام مكافحة الجرائم المعلوماتية الصادر بالمرسوم الملكي رقم م/17وتاريخ 08/03/1428, وبجميع الأنظمة ذات الصلة </span>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <span id="securityVonfirmRequiredMsg" data-i18n="confirmation_approval" style={{ color: "red", display: "none", fontSize:"11px" }}>الرجاء الموافقه على الإقرار   </span>
                                    </div>
                                    <br></br>
                                    <div className='row'>
                                        <button  className="btn btn-success btn1" id="submitbtn" data-i18n="submit_btn" onClick={this.openWelcomeScreen}>استمرار
                                                &nbsp;&nbsp;<span id="submitButtonSpinner" style={{display:"none"}} className="spinner-border spinner-border-sm"></span>
                                        </button>
                                    </div>
</div>
                                   
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state: State, props: CommonProps) => ({
    serviceType: state.common.serviceType
});

const mapDispatchToProps = (dispatch: any, props: CommonProps) => ({
    setServiceType: (serviceType: string) => dispatch(setServiceType(serviceType)),
    setFullName: (fullName: string) => dispatch(setFullName(fullName)),
    setNin: (nin: string) => dispatch(setNin(nin)),
    setMobile: (mobile: string) => dispatch(setMobile(mobile)),
    setToken: (token: string) => dispatch(setToken(token))
});

const connector: any = connect(mapStateToProps, mapDispatchToProps);
export default connector(InputForm);
